module.exports = __webpack_public_path__ + "aa9c3c5afb88edda5656e60b7abe7f63.png";